import config from './config.data.json';

export const API_URL = process.env.REACT_APP_URL || config.API_URL;
export const APP_URL = process.env.REACT_APP_APP_URL || config.APP_URL;

export const API_URL1 = config.API_URL1;
export const APP_URL1 = config.APP_URL1;

export const APP_CHECKER = config.APP_CHECKER;
export const APP_ID = config.APP_ID;

// optional: default export (legacy support)
export default config;
